














import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { getPublishedItinerary, getItineraryDetail } from "@/api/scheduleManagement/index";
import topItem from "@/components/common/header/index.vue";
import { Cell, Pagination, Button, Loading } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    [Loading.name]: Loading,
    topItem,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  componentName = topItem;
  detailContent = "";
  id: any = "";
  created() {
    this.id = this.$route.query.id;
    this.getDetail(this.id);
  }

  mounted() {}

  getDetail(id: any) {
    this.loading = true;
    let param = { itId: id };
    getItineraryDetail(param)
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.detailContent = data.regulation.replace(/<img/g, "<img style='width:100%'");
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
  goRegister() {
    let token = localStorage.getItem("token");
    if (token) {
      // deliver
      this.$router.push({ path: "deliverResume", query: { id: this.id } });
    } else {
      this.$router.push({ path: "register", query: { id: this.id } });
    }
  }
}
